import { environmentHttpClient } from "client/Api/httpClient";

export type AfasConnectionSelectOptionModel = {
	id: number;
	name: string;
};

export interface AfasConnectionSelectOptionsModel {
	canCreateNew: boolean;
	options: AfasConnectionSelectOptionModel[];
}

export type AutotaskConnectionSelectOptionModel = {
	id: number;
	name: string;
};

export type AutotaskConnectionSelectOptionsModel = {
	canCreateNew: boolean;
	options: Array<AutotaskConnectionSelectOptionModel>;
};

export type ZaaksysteemConnectionSelectOptionModel = {
	id: number;
	name: string;
};

export type ZaaksysteemConnectionSelectOptionsModel = {
	canCreateNew: boolean;
	options: Array<ZaaksysteemConnectionSelectOptionModel>;
};

export type VilansKickConnectionSelectOptionModel = {
	id: number;
	name: string;
};

export type VilansKickConnectionSelectOptionsModel = {
	canCreateNew: boolean;
	options: Array<VilansKickConnectionSelectOptionModel>;
};

export type NedapOnsConnectionSelectOptionModel = {
	id: number;
	name: string;
};

export type NedapOnsConnectionSelectOptionsModel = {
	canCreateNew: boolean;
	options: Array<NedapOnsConnectionSelectOptionModel>;
};

export type LiquitConnectionSelectOptionModel = {
	id: number;
	name: string;
};

export type LiquitConnectionSelectOptionsModel = {
	canCreateNew: boolean;
	options: Array<LiquitConnectionSelectOptionModel>;
};

export type MagisterConnectionSelectOptionModel = {
	id: number;
	name: string;
};

export type MagisterConnectionSelectOptionsModel = {
	canCreateNew: boolean;
	options: readonly MagisterConnectionSelectOptionModel[];
};

export type ZenyaDocConnectionSelectOptionModel = {
	id: number;
	name: string;
};

export type ZenyaDocConnectionSelectOptionsModel = {
	canCreateNew: boolean;
	options: Array<ZenyaDocConnectionSelectOptionModel>;
};

export type ZermeloConnectionSelectOptionModel = {
	id: number;
	name: string;
};

export type ZermeloConnectionSelectOptionsModel = {
	canCreateNew: boolean;
	options: Array<ZermeloConnectionSelectOptionModel>;
};

export function getAfasConnections(
	signal?: AbortSignal
): Promise<AfasConnectionSelectOptionsModel> {
	return environmentHttpClient.get<AfasConnectionSelectOptionsModel>(
		"Apps/Parameters/Afas/Connections",
		undefined,
		{ signal }
	);
};

export function getAutotaskConnections(
	signal?: AbortSignal
): Promise<AutotaskConnectionSelectOptionsModel> {
	return environmentHttpClient.get<AutotaskConnectionSelectOptionsModel>(
		"/Apps/Parameters/Autotask/Connections",
		undefined,
		{ signal }
	);
};

export function getZaaksysteemConnections(
	signal?: AbortSignal
): Promise<ZaaksysteemConnectionSelectOptionsModel> {
	return environmentHttpClient.get<ZaaksysteemConnectionSelectOptionsModel>(
		"/Apps/Parameters/Zaaksysteem/Connections",
		undefined,
		{ signal }
	);
};

export function getNedapOnsConnections(
	signal?: AbortSignal
): Promise<NedapOnsConnectionSelectOptionsModel> {
	return environmentHttpClient.get<NedapOnsConnectionSelectOptionsModel>(
		"/Apps/Parameters/NedapOns/Connections",
		undefined,
		{ signal }
	);
};

export function getNedapOnsOrganisationName(
	appId: number,
	signal?: AbortSignal
): Promise<string> {
	return environmentHttpClient.get<string>(
		`/Apps/Parameters/NedapOns/${appId}/OrganisationName`,
		undefined,
		{ signal }
	);
};

export function getZenyaDocConnections(
	signal?: AbortSignal
): Promise<ZenyaDocConnectionSelectOptionsModel> {
	return environmentHttpClient.get<ZenyaDocConnectionSelectOptionsModel>(
		"/Apps/Parameters/Zenya/Connections",
		undefined,
		{ signal }
	);
};

export type ClientlessRdpGatewayOptionModel = {
	id: number;
	name: string;
};

export type ClientlessRdpConnectionOptionModel = {
	id: string;
	name: string;
};

export function getClientlessRdpGateways(
	signal?: AbortSignal
): Promise<ClientlessRdpGatewayOptionModel[]> {
	return environmentHttpClient.get<ClientlessRdpGatewayOptionModel[]>(
		"/Apps/Parameters/ClientlessRdp/Gateways",
		undefined,
		{ signal }
	);
};

export function getClientlessRdpConnections(
	gatewayId: number,
	signal?: AbortSignal
): Promise<ClientlessRdpConnectionOptionModel[]> {
	return environmentHttpClient.get<ClientlessRdpConnectionOptionModel[]>(
		`/Apps/Parameters/ClientlessRdp/Gateways/${gatewayId}/Connections`,
		undefined,
		{ signal }
	);
};

export function getLiquitConnections(
	signal?: AbortSignal
): Promise<LiquitConnectionSelectOptionsModel> {
	return environmentHttpClient.get<LiquitConnectionSelectOptionsModel>(
		"/Apps/Parameters/Liquit/Connections",
		undefined,
		{ signal }
	);
};

export function getMagisterConnections(
	signal?: AbortSignal
): Promise<MagisterConnectionSelectOptionsModel> {
	return environmentHttpClient.get<MagisterConnectionSelectOptionsModel>(
		"/Apps/Parameters/Magister/Connections",
		undefined,
		{ signal }
	);
};

export function getVilansKickConnections(
	signal?: AbortSignal
): Promise<VilansKickConnectionSelectOptionsModel> {
	return environmentHttpClient.get<VilansKickConnectionSelectOptionsModel>(
		"/Apps/Parameters/VilansKick/Connections",
		undefined,
		{ signal }
	);
}

export type TopDeskConnectionSelectOptionModel = {
	id: number;
	isDefault: false;
	name: string;
} | {
	isDefault: true;
	name: string;
};

export type TopDeskConnectionSelectOptionsModel = {
	canCreateNew: boolean;
	options: readonly TopDeskConnectionSelectOptionModel[];
};

export function getTopDeskConnections(
	signal?: AbortSignal
): Promise<TopDeskConnectionSelectOptionsModel> {
	return environmentHttpClient.get<TopDeskConnectionSelectOptionsModel>(
		"/Apps/Parameters/TopDesk/Connections",
		undefined,
		{ signal }
	);
};

export function getZermeloConnections(
	signal?: AbortSignal
): Promise<AfasConnectionSelectOptionsModel> {
	return environmentHttpClient.get<AfasConnectionSelectOptionsModel>(
		"/Apps/Parameters/Zermelo/Connections",
		undefined,
		{ signal }
	);
};

export type IntegrationAppConnectionModel = {
	name: string;
	id: number;
};

export function getIntegrationAppConnections(
	signal?: AbortSignal
): Promise<readonly IntegrationAppConnectionModel[]> {
	return environmentHttpClient.get<readonly IntegrationAppConnectionModel[]>(
		"Apps/Parameters/Integration/Connections",
		undefined,
		{ signal }
	);
}